export const LOGIN_BUTTON_INDEX = 1

export const DEFAULT_DROPDOWN_DATA = {
	audur_dropdown_button_title: 'Stofna reikning',
	audur_dropdown_values: [
		{
			audur_dropdown_value_text: 'Einstaklingar',
			audur_dropdown_value_link: 'https://netbanki.audur.is',
		},
		{
			audur_dropdown_value_text: 'Fyrirtæki og félög',
			audur_dropdown_value_link: 'https://netbanki.audur.is/?user=company',
		},
	],
}
